module.exports = "<mat-card class=\"card\">\r\n  <mat-card-header>\r\n    <mat-card-title>\r\n      Logs\r\n    </mat-card-title>\r\n  </mat-card-header>\r\n\r\n  <mat-card-content class=\"\">\r\n\r\n    <div *ngFor=\"let log of logs\" style=\"padding:2px 10px; font-family:'Palatino Linotype',sans-serif;\">\r\n      <small>{{log.time | date:'h:mm a M/dd/yy '}}: {{log.message | json}}</small>\r\n    </div>\r\n\r\n  </mat-card-content>\r\n</mat-card>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/mybrokenwalls/workspace/mybrokenwalls/portfolio/src/app/components/logs/logs.component.html
// module id = ../../../../../src/app/components/logs/logs.component.html
// module chunks = main